/**
 * Static reflection of the project's Supabase auth configuration.
 *
 * These flags are set on the backend via `supabase.configure_auth` (see the
 * project migration history). The client cannot introspect the auth config at
 * runtime, so we mirror the intended state here and surface it in the UI so
 * users know which protections are active on their account.
 *
 * If you change a value in the backend auth config, update it here too.
 */
export const AUTH_CONFIG = {
  /** HIBP "Pwned Passwords" check on signup and password change. */
  passwordHibpEnabled: true,
  /** Anonymous sign-ins (guest sessions with no email). */
  anonymousSignInsEnabled: false,
  /** Auto-confirm email addresses without a verification click. */
  autoConfirmEmail: false,
} as const;

export type AuthConfig = typeof AUTH_CONFIG;
